import {
  Button,
  Flex,
} from "antd";
import {
  PlusOutlined,
} from "@ant-design/icons";
import React from "react";
import { SvgIcons } from "Icon/SvgIcons";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
interface ProjectScreeningSavedSearchesHeaderProps {
  selectedPool: number;
  getLastTab: () => number | null; // Function that returns a number
  popTab: () => void; // Function that pops the last tab, returns nothing
  currentIndex: number;
  setCurrentIndex: React.Dispatch<React.SetStateAction<number>>;
  setState: React.Dispatch<React.SetStateAction<string>>;
}

const ProjectScreeningSavedSearchesHeader: React.FC<ProjectScreeningSavedSearchesHeaderProps> = ({
  selectedPool,
  getLastTab,
  popTab,
  currentIndex,
  setCurrentIndex,
  setState,
}) => {
  const navigate = useNavigate();
  const projectDetails = useSelector((state: any) => state.projectSlice?.selected_project || {});
  const previousIndex = getLastTab();

  const handleBackTab = () => {
    if (currentIndex !== previousIndex) {
      popTab();
      if (previousIndex === 1) {
        setCurrentIndex(1);
        navigate(`/projects/analytics/${selectedPool}`);
      } 
      else if (previousIndex === 2) {
        setCurrentIndex(2);
        navigate(`/projects/saved-searches/${selectedPool}`);
      } else if (previousIndex === 3) {
        setCurrentIndex(3);
        navigate(`/projects/recent-searches/${selectedPool}`);
      } else if (previousIndex === 4) {
        setCurrentIndex(4);
        navigate(`/projects/talent-pool/${selectedPool}`);
      } else if (previousIndex === 99) {
        setCurrentIndex(99);
        navigate(`/projects/details/${selectedPool}`);
      } else if (!previousIndex) {
        navigate(`/projects/`);
      }
    }
  };

  return (
    <>
      <Flex justify="space-between" className="pr-4 h-[51px] border-b bg-white" align="center">
        <div className="flex gap-2 items-center">
          <span
            onClick={handleBackTab}
            style={{ cursor: currentIndex === previousIndex ? "" : "pointer" }}
            className="w-9 h-9 p-2 flex justify-between items-center rounded-r-lg cursor-pointer "
          >
            {SvgIcons.arrowNarrowLeft}
          </span>
          <p className="text-text-heading font-bold text-xl">
            Screening Folder: &nbsp;
            <span className="text-xl font-semibold text-text-secondary capitalize">
              {projectDetails?.title || projectDetails?.project_name}
            </span>
          </p>
        </div>
        {/* <Flex align="center" gap={24}>
          <Button
            className="relative font-semibold text-sm text-white py-2 px-3 bg-[#845dda] border border-[#7F56D9] flex gap-1 rounded-lg group"
            onClick={() => {
              navigate(`/`);
            }}
          >
            <PlusOutlined />Save Draft
          </Button>
        </Flex> */}
      </Flex>
    </>
  );
};

export default ProjectScreeningSavedSearchesHeader;
